import { render, staticRenderFns } from "./insureform.vue?vue&type=template&id=713cbdc4&scoped=true"
import script from "./insureform.vue?vue&type=script&lang=js"
export * from "./insureform.vue?vue&type=script&lang=js"
import style0 from "./insureform.vue?vue&type=style&index=0&id=713cbdc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713cbdc4",
  null
  
)

export default component.exports